import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import { getPatternWatchlistsFulfilled } from '../../api/pattern-watchlist.api';
import type { PatternWatchlist } from '../types/pattern-watchlist';
import type { PatternWatchlistSchema } from '../types/pattern-watchlist.schema';

const initialState: PatternWatchlistSchema = {
    selectedPatternWatchlistId: null,
};

const patternWatchlistSlice = createSlice({
    name: 'patternWatchlist',
    initialState,
    reducers: {
        setSelectedPatternWatchlistId: (
            state,
            action: PayloadAction<number | null>,
        ) => {
            state.selectedPatternWatchlistId = action.payload;
        },
        resetSelectedPatternWatchlistId: (state) => {
            state.selectedPatternWatchlistId = null;
        },
    },
    extraReducers: (builder) =>
        builder.addMatcher(
            getPatternWatchlistsFulfilled,
            (state, action: PayloadAction<PatternWatchlist[]>) => {
                const watchlists = action.payload;

                // Reset selection if no watchlists exist
                if (!Array.isArray(watchlists) || watchlists.length === 0) {
                    state.selectedPatternWatchlistId = null;

                    return;
                }

                // Reset selection if the selected watchlist no longer exists
                if (state.selectedPatternWatchlistId !== null) {
                    const isSelectedWatchlistExists = watchlists.some(
                        (watchlist) =>
                            watchlist.id === state.selectedPatternWatchlistId,
                    );

                    if (!isSelectedWatchlistExists) {
                        state.selectedPatternWatchlistId = null;
                    }
                }
            },
        ),
});

export const {
    actions: patternWatchlistActions,
    reducer: patternWatchlistReducer,
} = patternWatchlistSlice;
